import { addClass, removeClass } from '../../utils/ie9polyfills';

const body = document.getElementsByTagName('BODY')[0];

export const POPULATE_CONTENT = payload => dispatch => {
  addClass(body, ' noScroll');
  dispatch({ type: 'POPULATE_CONTENT', payload });
};

export const CLOSE_OVERLAY = pageYOffset => dispatch => {
  removeClass(body, 'noScroll');
  // this pageoffset is only passed on mobile overlays,
  // so when you close them, the document scrolls to the previous position
  if (pageYOffset) {
    window.scrollTo(0, pageYOffset);
  }
  dispatch({ type: 'CLOSE_OVERLAY' });
};

export const TOGGLE_CUSTOMIZATION = isOpen => {
  return {
    type: 'TOGGLE_CUSTOMIZATION',
    payload: isOpen
  };
};
